/* eslint-disable global-require */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';

import './index.less';
import { applyMiddleware, createStore } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { ThemeProvider } from 'styled-components';
import history from './history';
import theme from './theme';
import * as serviceWorker from './serviceWorker';

import reducers from './state/reducers';
import sagas from './state/sagas';

import App from './App';
import configureStore from "./configureStore";
import AppPersistWrapper from "./AppPersistWrapper";

const pk = require('../package.json');

const middlewares = [];
export const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['core', 'auth', 'app'],
};
if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

const initialStoreCongig = configureStore({}, middlewares);

document.title = `GIOWEB2 - ${pk.version}`;
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <AppPersistWrapper initialStoreCongig={initialStoreCongig} middlewares={middlewares} />
  </ThemeProvider>,
  document.getElementById('root'),
);

serviceWorker.register();
